export default {
  data () {
    return {
      api: process.env.NODE_ENV !== 'production' ? `https://localhost:21158/` : `/`
    }
  }
}

